import "./assets/css/base.common.less";
import Vue from 'vue'
import VueRouter from 'vue-router'
import store from './store'
import App from './App.vue'
import VueFullpage from 'vue-fullpage.js'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/swiper-bundle.css'
import Home from '@/Home'
import News from '@/News'
import NewsDetail from '@/NewsDetail'
import * as api from './service'
import { Toast } from "vant";
import "vant/lib/toast/style";

Vue.use(VueRouter).use(VueFullpage).use(VueAwesomeSwiper).use(Toast)
Vue.prototype.$api = api;
const routes = [
  { path: '/', name: 'home', component: Home },
  { path: '/news', name: 'news', component: News },
  { path: '/detail', name: 'detail', component: NewsDetail }
]

const router = new VueRouter({
  routes // (缩写) 相当于 routes: routes
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
